import { after } from 'scripts/infrastructure/backends/http_client';
import mixin from '../../lib/mixin';
import Observable from '../../lib/observable_mixin';

export default class RelationshipLabelHttpGateway {
  constructor(backend, requestorId) {
    this.backend = backend;
    this.mqttClient = backend;
    this.requestorId = requestorId;
  }

  init({ orgId } = {}) {
    this.orgId = orgId;
  }

  get version() {
    return '1';
  }

  get broadcastTopic() {
    return `v${this.version}/orgs/${this.orgId}/relationship-labels`;
  }

  get _http() {
    return this.backend.axios();
  }

  reconnectHandler() {
    if (this._isSubscribed) {
      this.request();
    }
  }

  handleBroadcast(envelope) {
    this.notifyObservers('handleFetchLabels', envelope.payload);
  }

  url(labelId = '') {
    let labelIdParam = labelId ? `/${labelId}` : '';
    return `/api/v${this.version}/orgs/${this.orgId}/relationship-labels${labelIdParam}`;
  }

  request() {
    this._isSubscribed = true;
    this.mqttClient.subscribe(this.broadcastTopic, this.handleBroadcast.bind(this), this.fetch.bind(this));
  }

  /* HTTP Methods */

  add(labelPayload) {
    return after(this._http.post(this.url(), labelPayload), this.onPost.bind(this));
  }

  fetch() {
    return after(this._http.get(this.url()), this.onGetAll.bind(this));
  }

  remove(labelId) {
    return after(this._http.delete(this.url(labelId)), this.onDelete.bind(this));
  }

  update(labelId, labelPayload) {
    return after(this._http.put(this.url(labelId), labelPayload), this.onPut.bind(this));
  }

  updateDeprecated(labelPayload) {
    return after(this._http.put(this.url(), labelPayload), this.onPut.bind(this));
  }

  /* Handlers */

  onPost(err, res) {
    if (err) {
      this.notifyObservers('handleAddError', err);
      return;
    }
    if (res.status === 204) {
      this.notifyObservers('handleAddLabel', {});
    } else {
      this.notifyObservers('handleAddError', res.data);
    }
  }

  onGetAll(err, res) {
    if (err) {
      this.notifyObservers('handleFetchLabelsError', err);
      return;
    }
    if (res.status === 200) {
      this.notifyObservers('handleFetchLabels', res.data);
    } else {
      this.notifyObservers('handleFetchLabelsError', res.data);
    }
  }

  onDelete(err, res) {
    if (err) {
      this.notifyObservers('handleRemoveError', err);
      return;
    }
    if (res.status === 204) {
      this.notifyObservers('handleRemoveSuccess', {});
    } else {
      this.notifyObservers('handleRemoveError', res.data);
    }
  }

  onPut(err, res) {
    if (err) {
      this.notifyObservers('handleUpdateError', err);
      return;
    }
    if (res.status === 204) {
      this.notifyObservers('handleUpdateSuccess', {});
    } else {
      this.notifyObservers('handleUpdateError', res.data);
    }
  }
}

mixin(RelationshipLabelHttpGateway.prototype, Observable);



// WEBPACK FOOTER //
// ./src/scripts/adapters/gateways/relationship_label_http_gateway.js